module.exports = __webpack_public_path__ + "assets/blue_eye-con.6c5f9133.svg";